var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90011 8L15.6004 13.7003C16.1332 14.2331 16.1332 15.0677 15.6004 15.6004C15.0677 16.1332 14.2331 16.1332 13.7003 15.6004L8 9.90011L2.29967 15.6004C1.76693 16.1332 0.932297 16.1332 0.399556 15.6004C-0.133185 15.0677 -0.133185 14.2331 0.399556 13.7003L6.09989 8L0.399556 2.29967C-0.133185 1.76693 -0.133185 0.932297 0.399556 0.399556C0.932297 -0.133185 1.76693 -0.133185 2.29967 0.399556L8 6.09989L13.7003 0.399556C14.2331 -0.133185 15.0677 -0.133185 15.6004 0.399556C16.1332 0.932297 16.1332 1.76693 15.6004 2.29967L9.90011 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.ea9fb0acb023ea3845bba0193bbcf9d5.svg";
export { ForwardRef as ReactComponent };